import { TypedDocumentNode, gql } from '@common/hooks';
import {
  HourBlockInfoQueryCgResponse,
  HourBlockInfoQueryVariables,
  ManagerWorkerTimesheetQueryCgResponse,
  ManagerWorkerTimesheetQueryVariables,
  ManagerWorkerTimesheetsQueryCgResponse,
  ManagerWorkerTimesheetsQueryVariables,
  WorkerTimesheetFiltersQueryCgResponse,
  WorkerTimesheetFiltersQueryVariables,
  WorkerTimesheetStatusCountsQueryCgResponse,
  WorkerTimesheetStatusCountsQueryVariables,
} from '@common/graphql/schema';
import {
  ReviewHourBlock,
  ReviewWorkerTimesheet,
  WorkerTimesheetList,
  WorkerTimesheetStatusCount,
} from '@timekeeping/graphql';

export const ManagerWorkerTimesheets: TypedDocumentNode<
  ManagerWorkerTimesheetsQueryCgResponse,
  ManagerWorkerTimesheetsQueryVariables
> = gql`
  query ManagerWorkerTimesheets(
    $filters: WorksTimekeepingManagerWorkerTimesheetsInput!
    $limit: Int!
    $offset: Int
  ) {
    page: worksTimekeepingPaginatedWorkerTimesheets(
      input: $filters
      limit: $limit
      offset: $offset
    ) {
      timesheets {
        ...WorkerTimesheetList
      }
      totalCount
    }
  }
  ${WorkerTimesheetList}
`;

export const WorkerTimesheetFilters: TypedDocumentNode<
  WorkerTimesheetFiltersQueryCgResponse,
  WorkerTimesheetFiltersQueryVariables
> = gql`
  query WorkerTimesheetFilters {
    options: worksTimekeepingWorkerTimesheetFilters {
      statuses
    }
  }
`;

export const WorkerTimesheetStatusCounts: TypedDocumentNode<
  WorkerTimesheetStatusCountsQueryCgResponse,
  WorkerTimesheetStatusCountsQueryVariables
> = gql`
  query WorkerTimesheetStatusCounts {
    counts: worksTimekeepingWorkerTimesheetsStatusCounts {
      ...WorkerTimesheetStatusCount
    }
  }
  ${WorkerTimesheetStatusCount}
`;

export const ManagerWorkerTimesheet: TypedDocumentNode<
  ManagerWorkerTimesheetQueryCgResponse,
  ManagerWorkerTimesheetQueryVariables
> = gql`
  query ManagerWorkerTimesheet($id: ID!) {
    timesheet: worksTimekeepingWorkerTimesheetById(id: $id) {
      ...ReviewWorkerTimesheet
    }
  }
  ${ReviewWorkerTimesheet}
`;

export const ReviewHourBlockInfo: TypedDocumentNode<
  HourBlockInfoQueryCgResponse,
  HourBlockInfoQueryVariables
> = gql`
  query HourBlockInfo($id: ID!) {
    hourBlockInfo: worksTimekeepingHourBlockInfo(id: $id) {
      data {
        ...ReviewHourBlock
      }
    }
  }
  ${ReviewHourBlock}
`;
